import styled from "styled-components";
import { Badge } from "@mui/material";

export const StyledBadge = styled(Badge)`
    .MuiBadge-badge {
        transform: scale(1) translate(70%, -70%);
    }
`;
